import { Router } from '@angular/router';
import { NewLoginWidgetContextType } from '../models/new-login-widget-types';

/**
 * Controlling Class which is used for Okta Login Screen UI Update Operations.
 */
export class NewLoginWidgetControls {
    mfaScreenUpdated: boolean = false;
    mfaSendSMSForFirstTime: boolean = false;
    mfaSendEmailForFirstTime: boolean = false;

    private innerRouter: Router;
     constructor(router: Router) {
        this.innerRouter = router;
    }


    /**
     * 
     * @param context *Method is used for update the UI for Password reset page
     * @returns 
     */
    protected updatePasswordResetFlowUI(context: NewLoginWidgetContextType) {
        return;
    }
    /**
     * Method to Update Account Recovery Screen On UI Load with the help of JS.
     * @param context Okta Context Data type
     * @returns none
     */
    protected updateAccountRecoveryFlowUI(context: NewLoginWidgetContextType) {
         // adding icons
        this.waitForEl('a[data-se="sms-button"]', () => {
            let x = $('a[data-se="sms-button"]').text();
            let icon = $('<img>').prop("src", "assets/icons/chat_bubble_square.svg").width(24).height(24);
            $('a[data-se="sms-button"]')
                .html("")
                .addClass("d-flex align-items-center justify-content-start");
            $('a[data-se="sms-button"]').append(icon);
            $('a[data-se="sms-button"]').append(
                $("<span>")
                    .text(x)
                    .addClass('mx-3')
            );
        }, 600, 100);

        this.waitForEl('a[data-se="email-button"]', () => {
            let x = $('a[data-se="email-button"]').text();
            let icon = $('<img>').prop("src", "assets/icons/email.svg").width(24).height(24);
            $('a[data-se="email-button"]')
                .html("")
                .addClass("d-flex align-items-center justify-content-start");
            $('a[data-se="email-button"]').append(icon);
            $('a[data-se="email-button"]').append(
                $("<span>")
                    .text(x)
                    .addClass('mx-3')
            );
        }, 600, 100);

        this.waitForEl("label[for='account-recovery-username']", () => {
            $("label[for='account-recovery-username']").html('<span>Username | <a id="forgot-username" href="javascript:void(0)">Forgot Username?</a> ')
            $("#forgot-username").click(() => {
                this.innerRouter.navigateByUrl("/accountRecovery/step1")
            })
        }, 600, 100);
        
        

        
        return;
    }

    /**
     * Method to update UI of MFA setup screen with the help of JS.
     * @param context Okta Context Data Type
     * @returns none
     */
    protected updateMFAFlowUI(context: NewLoginWidgetContextType) {
        return;
    }

    /**
     * Method to Update MFA Verification screen with the help of JS.
     * @param context Okta Context Data type
     * @returns none
     */
    protected updateMFAVerificationFlowUI(context: NewLoginWidgetContextType) {
        const updateUi = () => {
            if ($(".icon.factor-icon.mfa-sms-30")[0] && $(".icon.factor-icon.mfa-email-30")[0]) {
                $("main.auth-container.main-container > .auth-content > .auth-content-inner > .mfa-verify > .o-form").hide();
                if (!$("#custom-auth-buttons")[0]) {
                    $("main.auth-container.main-container > .auth-content > .auth-content-inner > .mfa-verify > .o-form").after(
                        $("<div>").addClass("custom-auth-buttons").html(`
                            <div class="row g-3">
                                <button class="button button-primary col-12 mb-5 d-flex align-items-center justify-content-start" id="mfa-verify-sms-authentication" style="z-index: 10000;"> 
                                    <img src="assets/icons/chat_bubble_square.svg" width="24" height="24" />    
                                    <span class="mx-3"> Text Message </span>
                                </button>
                                <button class="button button-primary col-12 mb-5 d-flex align-items-center justify-content-start" id="mfa-verify-email-authentication" style="z-index: 10000;"> 
                                    <img src="assets/icons/email.svg" width="24" height="24" />    
                                    <span class="mx-3"> Email </span>
                                </button>
                            </div>
                        `).prop('id', 'custom-auth-buttons')
                    );

                    this.waitForEl('#mfa-verify-sms-authentication', () => {
                        $("#mfa-verify-sms-authentication")
                            .removeClass("link-button-disabled")
                            .prop('disabled', false);

                    }, 600, 100);
                    this.waitForEl('#mfa-verify-email-authentication', () => {
                        $("#mfa-verify-email-authentication")
                            .removeClass("link-button-disabled")
                            .prop('disabled', false);
                    }, 600, 100);

                    $("#mfa-verify-sms-authentication").click(() => {
                        // make a click event and show the screen for sms authentication
                        $(".icon.factor-icon.mfa-sms-30")[0].click();
                        $("#custom-auth-buttons").remove();
                        $("main.auth-container.main-container > .auth-content > .auth-content-inner > .mfa-verify > .o-form").show();
                        this.waitForEl('.mfa-okta-sms', () => addHeader('text'), 600, 100);
                    });
                    $("#mfa-verify-email-authentication").click(() => {
                        // make a click event and show the screen for email authentication
                        $(".icon.factor-icon.mfa-email-30")[0].click();
                        $("#custom-auth-buttons").remove();
                        $("main.auth-container.main-container > .auth-content > .auth-content-inner > .mfa-verify > .o-form").show();
                        this.waitForEl('.mfa-okta-email', () => addHeader('email'), 600, 100);
                    });
                    addHeaderMessage('Please select an authentication method to receive a 6 digit code');
                    removeFooterText();
                }
            } else {
                this.mfaSendSMSForFirstTime = true;
                this.mfaSendEmailForFirstTime = true;
            }
            this.mfaScreenUpdated = true;
        }

        const addHeader = (mode: 'email' | 'text') => {
            if (mode === 'email') {

                if (this.mfaScreenUpdated && $(".o-form-button-bar > input[value='Send me the code']")[0]) {
                    $(".o-form-button-bar > input[value='Send me the code']")[0].click();
                    this.waitForEl('.mfa-okta-email', () => {
                        addHeader('email');
                        updateSMSandEmailAuthenticationScreen();
                    }, 600, 100);
                } else {
                    if (!this.mfaSendEmailForFirstTime) {
                        this.mfaSendEmailForFirstTime = true;
                        return;
                    }
                    if ($("#custom-auth-buttons")[0]) {
                        addHeaderMessage('Please select an authentication method to receive a 6 digit code');
                    } else {
                        let mailId = $(".mfa-email-sent-content > .mask-email").text();
                        addHeaderMessage(
                            'A 6 digit verification code was sent to ',
                            mailId,
                            'The code will expire in 10 minutes.'
                        );
                    }
                }
            } else if (mode === 'text') {
                if (this.mfaScreenUpdated) {
                    if (!this.mfaSendSMSForFirstTime) {
                        this.mfaSendSMSForFirstTime = true;
                        return;
                    }
                    const phoneNumber = $(".o-form-content > .okta-form-subtitle.o-form-explain").text();
                    addHeaderMessage(
                        'A 6 digit verification code was sent to ',
                        phoneNumber,
                        'The code will expire in 10 minutes.'
                    );
                    this.waitForEl('.mfa-okta-sms', () => {
                        $(".button.sms-request-button.link-button")[0].click();
                    }, 600, 100);
                    this.waitForEl('.mfa-okta-sms', () => {
                        $('.sms-request-button').removeClass("margin-top-30")
                    }, 600, 100)
                }
            }
        }

        const addHeaderMessage = (message1 = '', emailOrPhoneNumber = '', message2 = '') => {
            this.waitForEl('#mfa-verification-header-messages', () => {
                $("#mfa-verification-header-message-1").text(message1);
                $("#mfa-verification-header-message-2").text(`${emailOrPhoneNumber}.`);
                $("#mfa-verification-header-message-3").text(message2);
            }, 600, 100)
        }

        const removeHeaderMessage = () => {
            this.waitForEl('#mfa-verification-header-messages', () => {
                $("#mfa-verification-header-message-1").text('');
                $("#mfa-verification-header-message-2").text('');
                $("#mfa-verification-header-message-3").text('');
            }, 600, 100);
        }

        const updateSMSandEmailAuthenticationScreen = () => {

            if ($(".mfa-okta-sms")[0]) {
                addHeader('text');
                if ($(".icon.factor-icon.mfa-sms-30")[0] && $(".icon.factor-icon.mfa-email-30")[0]) {
                    if (!$("#didnt-receive-code-email")[0]) {
                        $(".o-form-button-bar > input.button.button-primary").after(
                            $("<div>")
                                .prop("id", "didnt-receive-code-email")
                                .addClass("font-weight-bold")
                                .html(`
                                    <p class="text-center">
                                        Didn't receive a code? 
                                        <a href="javascript:void(0)" id="okta-send-via-email-link" class="btn btn-link">
                                            Send via email
                                        </a>
                                    </p>
                                `)
                        )
                    }
                    $("#okta-send-via-email-link").click(() => {
                        removeFooterText();
                        $(".icon.factor-icon.mfa-email-30")[0].click();
                    })
                }
            } else if ($(".mfa-okta-email")[0]) {
                addHeader('email');
                if ($(".icon.factor-icon.mfa-sms-30")[0] && $(".icon.factor-icon.mfa-email-30")[0]) {
                    if (!$("#okta-send-via-sms-link")[0]) {
                        $(".o-form-button-bar > input.button.button-primary").after(
                            $("<div>")
                                .prop("id", "didnt-receive-code-sms")
                                .addClass("font-weight-bold")
                                .html(`
                                    <p class="text-center">
                                        Didn't receive a code? 
                                        <a href="javascript:void(0)" id="okta-send-via-sms-link" class="btn btn-link">
                                            Send via text
                                        </a>
                                    </p>
                                `)
                        )
                    }
                    $("#okta-send-via-sms-link").click(() => {
                        removeFooterText();
                        $(".icon.factor-icon.mfa-sms-30")[0].click();
                    })
                }
            }

            addFooterText();
        }

        const addFooterText = () => {
            if (!$("#okta-mfa-footer-display-message")[0]) {
                $(".auth-footer.clearfix").append(
                    $("<div>")
                        .addClass("mt-5 text-muter")
                        .prop("id", "okta-mfa-footer-display-message")
                        .html(`
                            <p class="text-center pt-2">
                                If you no longer have access to the email or mobile number we have on file, 
                                <br class="d-none d-md-block" />
                                please call Technical Support at 877-526-8390.
                            </p>
                        `)
                );
            }
            $(".o-form-input-name-rememberDevice > .custom-checkbox > label").text("Remember me on this device");
        }

        const removeFooterText = () => {
            $("#okta-mfa-footer-display-message").remove();
        }

        if (!this.mfaScreenUpdated) {
            this.waitForEl('.mfa-verify', updateUi, 600, 100);
        }
        this.waitForEl('.mfa-verify', updateSMSandEmailAuthenticationScreen, 600, 100);


        // setTimeout(updateSMSandEmailAuthenticationScreen, 200);
        // setTimeout(updateUi, 400);
        // updateUi();

        return;
    }

    /**
     * Method to update Password Expired Screen with the help of JS
     * @param context Okta Context Data type
     * @returns none
     */
    protected updatePasswordExpiredFlowUI(context: NewLoginWidgetContextType) {
        return;
    }


    /**
     * Method to update Forgot Password Screen with the help of JS
     * @param context Okta Context Data type
     * @returns none
     */
    protected updateForgotPasswordFlowUI(context: NewLoginWidgetContextType) {
         // adding icons
        this.waitForEl('a[data-se="sms-button"]', () => {
            let x = $('a[data-se="sms-button"]').text();
            let icon = $('<img>').prop("src", "assets/icons/chat_bubble_square.svg").width(24).height(24);
            $('a[data-se="sms-button"]')
                .html("")
                .addClass("d-flex align-items-center justify-content-start");
            $('a[data-se="sms-button"]').append(icon);
            $('a[data-se="sms-button"]').append(
                $("<span>")
                    .text(x)
                    .addClass('mx-3')
            );
        }, 600, 100);

        this.waitForEl('a[data-se="email-button"]', () => {
            let x = $('a[data-se="email-button"]').text();
            let icon = $('<img>').prop("src", "assets/icons/email.svg").width(24).height(24);
            $('a[data-se="email-button"]')
                .html("")
                .addClass("d-flex align-items-center justify-content-start");
            $('a[data-se="email-button"]').append(icon);
            $('a[data-se="email-button"]').append(
                $("<span>")
                    .text(x)
                    .addClass('mx-3')
            );
        }, 600, 100);

        // this.waitForEl("label[for='account-recovery-username']", () => {
        //     $("label[for='account-recovery-username']").html('<span>Username | <a id:"forgot-username" href:"javascript:void(0)">Forgot Username?</a> ')
        //     $("#forgot-username").click(() => {
        //         this.innerRouter.navigateByUrl("/accountRecovery/step1")
        //     })
        // }, 600, 100);
        // return;
    }

/**
     * Method to update Forgot Password sms otp verification Screen with the help of JS
     * @param context Okta Context Data type
     * @returns none
     */
    protected updateForgotPasswordSMSConfirmationFlowUI(context: NewLoginWidgetContextType) {
        this.waitForEl(".send-email-link p a", () => {
            $('.send-email-link p a').addClass('send-via-email')
        }, 600, 100);
        return;
    }

    /**
     * Method to update Forgot Password Email link verification Screen with the help of JS
     * @param context Okta Context Data type
     * @returns none
     */
    protected updateForgotPasswordEmailConfirmationFlowUI(context: NewLoginWidgetContextType) {
        return;
    }

    protected updateAccountUnlockedScreen(context: NewLoginWidgetContextType) {
        this.waitForEl('.account-unlocked', () => {
            this.innerRouter.navigateByUrl("/accountRecovery/success");
        }, 600, 100);
        return;
    }


     /**
     * Logic to set all the values to default.
     */
    protected resetDefaultValues() {
        this.mfaScreenUpdated = false;
        this.mfaSendSMSForFirstTime = false;
        this.mfaSendEmailForFirstTime = false;
    }


    /**
     * Wait for the specified element to appear in the DOM. When the element appears,
     * provide it to the callback.
     *
     * @param selector a jQuery selector (eg, 'div.container img')
     * @param callback function that takes selected element (null if timeout)
     * @param maxtries number of times to try (return null after maxtries, false to disable, if 0 will still try once) - recommended value is 600.
     * @param interval ms wait between each try - recommended value is 100.
     */
    private waitForEl(selector, callback, maxtries: number | boolean = false, interval = 100) {
        const poller = setInterval(() => {
            const el = jQuery(selector)
            const retry = maxtries === false || (<number>maxtries)-- > 0
            if (retry && el.length < 1) return // will try again
            clearInterval(poller)
            callback(el || null)
        }, interval)
    }
}


// WEBPACK FOOTER //
// ./src/app/new-login-widget/new-login-widget-custom-controls/new-login-widget.controller.ts